import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';

const EllipseContiner = styled.div`
	position: relative;
	width: 84px;
	height: 84px;
	flex-shrink: 0;
	margin: 0rem 0rem -6rem 13rem;
	z-index: 1;
`;

const Svg = styled.svg`
	width: 100%;
	height: 100%;

	${EmotionBreakpoint('tablet')} {
		width: none;
	}
`;

const EllipseShape = styled.ellipse`
	fill: ${(props) => props.cardColor || '#FF5733'};
`;

const CircleText = styled.text`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	color: #fff;
	text-align: center;
	font-family: 'Open Sans', sans-serif;
	font-size: 10px;
	font-style: normal;
	font-weight: 600;
	line-height: 12.8px;
	letter-spacing: 0.5px;
	text-transform: uppercase;
	z-index: 999999;
`;

const Ellipse = ({ text, cardColor }) => {
	return (
		<EllipseContiner>
			<Svg
				xmlns='http://www.w3.org/2000/svg'
				width='70'
				height='70'
				viewBox='0 0 70 70'
				fill='none'
			>
				<EllipseShape
					cx='34.9762'
					cy='34.9878'
					rx='34.9762'
					ry='34.9878'
					cardColor={cardColor}
				/>
			</Svg>
			<CircleText x='50%' y='50%'>
				{text}
			</CircleText>
		</EllipseContiner>
	);
};

export default Ellipse;
